import CreditInfoMenu from "./components/CreditInfoMenu";
import WalletLayout from "../components/WalletLayout";
import Credit from "./components/Credit";
import Cta from "~components/Cta";
import useHeader from "~components/Header/hooks/useHeader";
import { initialPath } from "~misc/paths";
import { useParams } from "react-router-dom";
import { useConfigureFooter } from "~hooks/useHelpers";
import { useEffect, useState } from "react";
import useCliente from "~/fetchs/useCliente";
import { Spinner } from "@chakra-ui/react";

const CreditInfo = () => {
  const { path } = useHeader();
  const { parameter: id } = useParams();

  const [backRoute, setBackRoute] = useState(null);
  const [recebedorEmissor, setRecebedorEmissor] = useState(false);

  useConfigureFooter(
    {
      form: true,
      backRoute,
      formId: "recebedor",
      submitLabel: "Concluir Solicitação",
      submitVariation: "green",
    },
    [backRoute]
  );

  const [loading, setLoading] = useState(true);

  let cliente = {};

  if (id)
    cliente = useCliente(id).cliente;

  useEffect(() => {
    if (cliente) {
      if ([1, 2].includes(cliente.tipo)) setRecebedorEmissor(true);

      setLoading(false);
    }
  }, [cliente]);

  return (
    <WalletLayout>
      {path == `${initialPath}/carteira/credito/novo` ? (
        <>
          <Cta title="Limite de Crédito" />
          <Credit setBackRoute={setBackRoute} />
        </>
      ) : (
        <>
          {loading ? (
            <div className="py-6 flex justify-center">
              <Spinner />
            </div>
          ) : (
            <>
              <CreditInfoMenu id={id} editSender={recebedorEmissor} />
              <Credit id={id} setBackRoute={setBackRoute} setRecebedorEmissor={setRecebedorEmissor} cliente={cliente} />
            </>
          )}
        </>
      )}
    </WalletLayout>
  );
};

export default CreditInfo;
